import { observable, action, _allowStateChangesInsideComputed } from "mobx";
import Autobind from "autobind-decorator";
import RootStore from "./rootStore";
import Config from "config";

/**
 * Element View 설정 정보에 대한 State 관리 Store
 * @constructor
 * @param {RootStore}
 */
@Autobind
class ElementViewConfigStore {
  // rootStore 객체. 다른 Store를 연계할 때 사용
  _rootStore: RootStore;

  // Metatag Text color

  @observable _metadataTextColor: String = Config.elementView.metadataTextColor;
  // FIXME : typescript 공부해서 아래 any 부분 명확하게 수정
  @observable _attributes: any = {
    metadataTextColor: Config.elementView.metadataTextColor,
  };
  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }

  getConfigAttribute(attributeName: string) {
    if (this._attributes.hasOwnProperty(attributeName) === false) {
      throw "Error : no attributes";
      return null;
    }
    const attributeValue = this._attributes[attributeName];
    return attributeValue;
  }

  @action setConfigAttribute(attributeName: string, value: any) {
    if (this._attributes.hasOwnProperty(attributeName) === false) {
      throw "Error : no attributes";
      return false;
    }
    this._attributes[attributeName] = value;
    return true;
  }

  @action setConfigAttributes(appearance: { [key: string]: any }) {
    for (const prop in appearance) {
      const value = appearance[prop];
      this._attributes[prop] = value;
    }
  }

  saveConfigAttributesInLocalStorage() {
    localStorage.setItem("appearance", JSON.stringify(this._attributes));
  }
}

export default ElementViewConfigStore;
